import NotificationCartsExpiringSoon from '../components/notifications/NotificationCartsExpiringSoon.vue';
import NotificationRecurringOrderProductNotActive from '../components/notifications/NotificationRecurringOrderProductNotActive.vue';
import NotificationRecurringOrderProductNotEnoughStock from '../components/notifications/NotificationRecurringOrderProductNotEnoughStock.vue';

export default {
  components: {
    NotificationCartsExpiringSoon,
    NotificationRecurringOrderProductNotActive,
    NotificationRecurringOrderProductNotEnoughStock,
  },
};
